import { type SampleDefinitionRowData } from './SamplePlanTableProvider';
import { modalAction } from '@/utils/modal';
import { type Dispatch } from 'redux';
import { type StudyApiId, type StudyType } from '@/model/Study.model.ts';
import { Status } from '@/referenceData/study/status';
import { COLLECTION_STATUS_TOOLTIPS, type CollectionStatus } from '@/model/SamplePlan.model.ts';
import { _notNil } from '@/littledash';

export const compareSampleDefinitionsByName = (
  left: SampleDefinitionRowData,
  right: SampleDefinitionRowData
): number => {
  return (left.name ?? '').localeCompare(right.name ?? '', undefined, { numeric: true });
};

const getCollectionStatusTooltip = (status: CollectionStatus): string | undefined => {
  return COLLECTION_STATUS_TOOLTIPS[status];
};

export const samplePlanBulkActions = (
  studyApiId: StudyApiId,
  selectedSampleDefinitions: Array<SampleDefinitionRowData>,
  resetSelection: () => void,
  dispatch: Dispatch,
  navigateToSampleExecuteStepForm: () => void,
  navigateToSamplesTable: () => void,
  studyStatus?: StudyType,
  collectionStatus?: CollectionStatus
) => {
  const { openModal, closeModal } = modalAction(dispatch);

  const handleCallback = () => {
    closeModal();
    resetSelection();
    navigateToSamplesTable();
  };

  const sectionOne = [];

  if (selectedSampleDefinitions.length > 0) {
    const isAwaitingReview = studyStatus === Status.awaiting_approval;
    const isCollectionDisabled = _notNil(collectionStatus) && collectionStatus !== 'available';
    const collectionTooltip = _notNil(collectionStatus) ? getCollectionStatusTooltip(collectionStatus) : '';

    sectionOne.push({
      name: 'Create planned samples',
      action: () => {
        openModal('EXECUTE_SAMPLES', {
          studyApiId: studyApiId,
          sampleDefinitions: selectedSampleDefinitions,
          closeModal,
          handleCallback,
        });
      },
      disabled: isCollectionDisabled,
      tooltip: collectionTooltip,
    });

    if (!isAwaitingReview) {
      sectionOne.push({
        name: 'Collect samples',
        action: () => {
          navigateToSampleExecuteStepForm();
        },
        disabled: isCollectionDisabled,
        tooltip: collectionTooltip,
      });
    }
  }

  return sectionOne;
};
